var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_51518",
    "data-name": "Raggruppa 51518",
    transform: "translate(-1274 -5029)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_7",
    "data-name": "Ellisse 7",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1274 5029)",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_34860",
    "data-name": "Tracciato 34860",
    d: "M-384.266-793.377l-3.62,16.966c-.268,1.2-.988,1.5-1.995.929l-5.518-4.042-2.658,2.547a1.394,1.394,0,0,1-1.113.54l.391-5.581,10.227-9.184c.446-.389-.1-.61-.685-.221l-12.637,7.909-5.444-1.69c-1.183-.377-1.21-1.177.254-1.743l21.28-8.156c.987-.354,1.851.239,1.53,1.724Z",
    transform: "translate(1690.186 5834.204)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ae5431ed6254a758128b04c751acc5af.svg";
export { ForwardRef as ReactComponent };